// src/pages/profile/ChangePasswordPage.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiArrowLeft, FiLock, FiCheckCircle, FiAlertCircle } from "react-icons/fi";
import TextInput from "../../components/common/TextInput";
import Button from "../../components/common/Button";
import { changePassword } from "../../api/userApi";
import { useAuth } from "../../hooks/useAuth";

function ChangePasswordPage() {
  const {user} = useAuth()
  const userId = user.user_id
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!form.currentPassword || !form.newPassword || !form.confirmNewPassword) {
      setError("All fields are required.");
      return;
    }

    if (form.newPassword !== form.confirmNewPassword) {
      setError("New passwords do not match.");
      return;
    }

    // if (form.newPassword.length < 6) {
    //   setError("New password should be at least 6 characters.");
    //   return;
    // }

    try {
      setLoading(true);

      const payload = {
        current_password: form.currentPassword,
        new_password: form.newPassword,
      };

      const data = await changePassword(payload, userId);

      setSuccess(data.message || "Password changed successfully.");
      setForm({
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      });
    } catch (err) {
      console.error(err);
      setError("Failed to change password. Please check your current password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl mx-auto">
      <div className="animate-fadeIn">
        <Link
          to="/profile"
          className="inline-flex items-center text-sm text-gray-600 hover:text-primary-600 transition-colors mb-4"
        >
          <FiArrowLeft className="mr-2 h-4 w-4" />
          Back to Profile
        </Link>

        <h1 className="text-3xl font-bold text-gray-900">
          Change Password
        </h1>
        <p className="text-gray-600 mt-1">
          Update your password to keep your account secure.
        </p>
      </div>

      {error && (
        <div className="card bg-gradient-to-br from-red-50 to-rose-50 border-red-200 animate-fadeIn">
          <div className="flex items-start gap-3">
            <FiAlertCircle className="h-5 w-5 text-red-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-red-700">{error}</p>
          </div>
        </div>
      )}

      {success && (
        <div className="card bg-gradient-to-br from-emerald-50 to-green-50 border-emerald-200 animate-fadeIn">
          <div className="flex items-start gap-3">
            <FiCheckCircle className="h-5 w-5 text-emerald-600 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-emerald-700">{success}</p>
          </div>
        </div>
      )}

      <form className="card-gradient animate-scaleIn space-y-5" onSubmit={handleSubmit}>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FiLock className="inline-block mr-2 h-4 w-4" />
            Current Password
          </label>
          <TextInput
            name="currentPassword"
            type="password"
            value={form.currentPassword}
            onChange={handleChange}
            placeholder="Enter your current password"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FiLock className="inline-block mr-2 h-4 w-4" />
            New Password
          </label>
          <TextInput
            name="newPassword"
            type="password"
            value={form.newPassword}
            onChange={handleChange}
            placeholder="Enter new password"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <FiLock className="inline-block mr-2 h-4 w-4" />
            Confirm New Password
          </label>
          <TextInput
            name="confirmNewPassword"
            type="password"
            value={form.confirmNewPassword}
            onChange={handleChange}
            placeholder="Re-enter new password"
          />
        </div>

        <Button type="submit" className="w-full" loading={loading} variant="primary">
          <FiLock className="inline-block mr-2 h-4 w-4" />
          Change Password
        </Button>
      </form>
    </div>
  );
}

export default ChangePasswordPage;
